(function ($) {
    $.fn.collapsible = function(options) {
        var defaults = {
            accordion: undefined
        };

        options = $.extend(defaults, options);


        return this.each(function() {

            var $this = $(this);
            var $panel_headers = $(this).find('> * > .collapsible-header, > .collapsible-header');
            var collapsible_type = $this.data("collapsible");

            // Turn off any existing event handlers
            $this.off('click.collapse', '> * > .collapsible-header');
            $panel_headers.off('click.collapse');

            // Add some ARIA stuff
            $panel_headers.attr('role','button').attr('aria-expanded','false').attr('tabindex','0');
            $panel_headers.each(function(){
                var newID = '';
                var $body = $(this).siblings('.collapsible-body');
                if($body[0].hasAttribute("id")){
                    newID = $body.attr('id')
                } else {
                    newID = generateUUID();
                    $body.attr('id', newID);
                }
                $(this).attr('aria-controls',newID);
                $body.attr('role','region').attr('tabindex', '-1');
            });

            /****************
            Helper Functions
            ****************/

            // Accordion Open
            function accordionOpen(object) {
                $panel_headers = $this.find('> * > .collapsible-header, > .collapsible-header');
                if (object.hasClass('is-active')) {
                    object.parent().addClass('is-active');
                    object.attr('aria-expanded','true');
                } else {
                    object.parent().removeClass('is-active');
                    object.attr('aria-expanded','false');
                }
                if (object.parent().hasClass('is-active')){
                    object.siblings('.collapsible-body').addClass("animated--quickly fadeIn").attr('aria-hidden','false');
                } else {
                    object.siblings('.collapsible-body').removeClass("animated--quickly fadeIn").attr('aria-hidden','true');
                }

                $panel_headers.not(object).removeClass('is-active').parent().removeClass('is-active');
                $panel_headers.not(object).parent().children('.collapsible-body').removeClass("animated--quickly fadeIn").attr('aria-hidden','true');
            }

            // Expandable Open
            function expandableOpen(object) {
                if (object.hasClass('is-active')) {
                    object.parent().addClass('is-active');
                }
                else {
                    object.parent().removeClass('is-active');
                }
                if (object.parent().hasClass('is-active')){
                    object.siblings('.collapsible-body').addClass("animated--quickly fadeIn").attr('aria-hidden','false');
                } else {
                    object.siblings('.collapsible-body').removeClass("animated--quickly fadeIn").attr('aria-hidden','true');
                }
            }

            /**
            * Check if object is children of panel header
            * @param  {Object}  object Jquery object
            * @return {Boolean} true if it is children
            */
            function isChildrenOfPanelHeader(object) {

                var panelHeader = getPanelHeader(object);

                return panelHeader.length > 0;
            }

            /**
            * Get panel header from a children element
            * @param  {Object} object Jquery object
            * @return {Object} panel header object
            */
            function getPanelHeader(object) {

                return object.closest('* > .collapsible-header');
            }

            /*****  End Helper Functions  *****/

            // Add click handler to only direct collapsible header children
            $this.on('click.collapse', '> * > .collapsible-header, > .collapsible-header', function(e) {
                var $header = $(this),
                element = $(e.target);

                if (isChildrenOfPanelHeader(element)) {
                    element = getPanelHeader(element);
                }

                element.toggleClass('is-active');

                if (options.accordion || collapsible_type === "accordion" || collapsible_type === undefined) { // Handle Accordion
                    accordionOpen(element);
                } else { // Handle Expandables
                    expandableOpen(element);
                    if ($header.hasClass('is-active')) {
                        expandableOpen($header);
                        $header.attr('aria-expanded','true');
                    } else {
                        $header.attr('aria-expanded','false');
                    }
                }
            });

            // Open first is-active
            var $panel_headers = $this.find('> * > .collapsible-header, > .collapsible-header');
            if (options.accordion || collapsible_type === "accordion" || collapsible_type === undefined) { // Handle Accordion
                accordionOpen($panel_headers.filter('.is-active').first());
            }
            else { // Handle Expandables
                $panel_headers.filter('.is-active').each(function() {
                    expandableOpen($(this));
                });
            }

        });
    };

    $(document).ready(function(){
        $('.collapsible').collapsible();
    });

}( jQuery ));
